export default [
  {
    id: 'f15f6c3b-5f15-4388-8834-7de2a50d01ba',
    path: 'system-administration',
    name: 'system-administration',
    meta: { title: '系统管理' },
    children: [
      {
        id: 'ab730ecd-9d3b-498d-9b9a-5114ca4875c9',
        path: 'data-dictionary',
        name: 'data-dictionary',
        component: () => {
          return import('../views/dictionnaryManagement/index')
        },
        meta: {
          title: '数据字典',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      // {
      //   id: '237d8fec-1c53-4973-96dd-425ec0b074aa',
      //   path: 'message-center',
      //   name: 'message-center',
      //   component: () => {
      //     return import('../views/messageManagement/messageCenter')
      //   },
      //   meta: { title: '消息中心' },
      // },
      // {
      //   id: '2de92644-a14a-45d3-a454-42b105ff881d',
      //   path: 'message-detail',
      //   name: 'message-detail',
      //   component: () => {
      //     return import('../views/messageManagement/messageDetail')
      //   },
      //   meta: { title: '查看消息', hidden: true },
      // },
      // {
      //   id: 'bc4e85ba-4faa-4212-9dc1-5d95f63c14f0',
      //   path: 'permission-management',
      //   name: 'permission-management',
      //   component: () => {
      //     return import('../views/permissionManagement/index')
      //   },
      //   meta: { title: '数据权限管理' },
      // },
      // {
      //   id: 'd463f202-960a-4062-9d52-e1066ef28a70',
      //   path: 'permission-add',
      //   name: 'permission-add',
      //   component: () => {
      //     return import('../views/permissionManagement/add')
      //   },
      //   meta: { title: '数据权限新增', hidden: true },
      // },
    ],
  },
]
